/**
 * Lets a screen ask for the in-app paywall to be opened.
 *
 * The paywall is owned by PaymentFlow, which is mounted beside every signed-in
 * page rather than above it, so a settings screen cannot open it through props.
 * It calls requestPaywall(); PaymentFlow subscribes with onPaywallRequested().
 * Same shape as the entitlement signal in `Utils/entitlementGate`, and kept
 * free of React and redux for the same reason: it can be tested on its own.
 */
type PaywallRequestListener = () => void;

const listeners = new Set<PaywallRequestListener>();

/** Subscribe to paywall requests. Returns the function that unsubscribes. */
export function onPaywallRequested(listener: PaywallRequestListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Ask for the paywall. One listener throwing must not stop the others or the caller. */
export function requestPaywall(): void {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // Opening the paywall is best effort for the screen that asked.
    }
  });
}
